exports = module.exports = require("../../../../../../../../../node_modules/@zxcabs/rtl-css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".third-step{width:100%;background:#fff;padding:20px}", ""]);

// exports
